import { apiClient } from './client'

export type ExternalConnection = {
  id: number
  provider: string
  label: string
  last_synced_at: string | null
}

export type SyncResult = {
  created: number
  updated: number
  total: number
}

export const getConnections = () =>
  apiClient.get<ExternalConnection[]>('/integrations/').then((r) => r.data)

export const connectService = (provider: string, token: string) =>
  apiClient
    .post<ExternalConnection>('/integrations/', { provider, token })
    .then((r) => r.data)

export const syncConnection = (id: number) =>
  apiClient.post<SyncResult>(`/integrations/${id}/sync/`).then((r) => r.data)

export const deleteConnection = (id: number) =>
  apiClient.delete(`/integrations/${id}/`).then((r) => r.data)
